import { Box, IconButton, Typography } from '@mui/material'
import { IconEditPencil, IconInfo } from 'assets/icons'
import { AdvancedTooltip, HelperInfo } from 'elements/feedback'
import React from 'react'

type SettingsItemProps = {
  title: string
  children?: React.ReactNode
  onClick?: () => void
  customButton?: React.ReactNode
  tooltipConfig?: { text: string; title: string }
}

export const SettingsItem = ({
  title,
  children,
  onClick,
  customButton,
  tooltipConfig,
}: SettingsItemProps) => {
  return (
    <Box
      bgcolor="common.white"
      border={1}
      borderColor="primary.light"
      borderRadius="12px"
      width="100%"
      p={3}
      boxShadow="0px 2px 10px 0px rgba(162, 162, 175, 0.12), 0px 1px 1px 0px rgba(237, 237, 248, 0.50)"
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex">
          <Typography variant="caption1" fontWeight={600}>
            {title}
          </Typography>

          {tooltipConfig && (
            <AdvancedTooltip
              placement="right"
              title={
                <HelperInfo
                  text={tooltipConfig.text}
                  title={tooltipConfig.title}
                />
              }
            >
              <IconButton sx={{ ml: 0.25 }}>
                <IconInfo sx={{ fontSize: '16px', mb: 1 }} />
              </IconButton>
            </AdvancedTooltip>
          )}
        </Box>

        {customButton ?? (
          <IconButton
            onClick={onClick}
            sx={{ flex: 'none', visibility: onClick ? 'visible' : 'hidden' }}
          >
            <IconEditPencil
              direction="right"
              sx={{ fontSize: '28px', color: 'primary.main' }}
            />
          </IconButton>
        )}
      </Box>

      {children && <Box mt={2}>{children} </Box>}
    </Box>
  )
}
